import { Button, Form, InputGroup, ProgressBar } from "react-bootstrap"
import { useDataGeneration, STATUS_SAVING } from "../api/generate/store"
import { useState } from "react";
import Loading from "./Loading";
import useUxStore from "../api/ux/store";

const DateRange = ({onClick = (date:string) => {}, loading=false}) => {
    const { cutoff, cancelGeneration, status, saveProgress } = useDataGeneration( state => state)
    const { refreshDialog, addToast } = useUxStore(state => state);
    const [date, setDate] = useState("");
    const [focus,setFocus] = useState(false)

    const monthValue = (value: string): string => {
        if (!value) return "";
        const [year, month] = value.split("-").map(Number);
        const lastDay = new Date(year, month, 0).getDate();
        return `${value}-${String(lastDay).padStart(2, "0")}`;
    };


    const handleCancel = () => {
        refreshDialog({
            id: "cancel-generation",
            title: "Cancel Generation",
            content: "Are you sure you want to cancel the ongoing generation process?",
            confirmContent: "Cancel Generation",
            confirmActive: true,
            visible: true,
            onConfirm: () => {
                cancelGeneration()
                    .then(result => {
                        if (result === "200") {
                            addToast("", "Generation cancelled successfully", null, "info");
                        }
                    })
                    .catch(err => {
                        addToast("Error", "Failed to cancel generation", null, "danger");
                    });
            }
        }, true);
    };
    
    return <div className="select-date">
            <InputGroup className="mb-3">
                <Form.Control
                    className="input-cutoff"
                    type={focus ? "month" : "text"}
                    name="datepic"
                    placeholder="Select Cutoff"
                    value={date}
                    //onChange={e => setDate(e.target.value)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDate(e.target.value)}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    disabled={loading}
                />
                {loading ? (
                    status === STATUS_SAVING ? (
                        <Button variant="info" disabled>
                            <Loading /> Saving... {saveProgress}%
                        </Button>
                    ) : (
                        <Button variant="danger" onClick={handleCancel}>
                            <Loading /> Cancel
                        </Button>
                    )
                ) : (
                    <Button onClick={() => onClick(monthValue(date))}>
                        Generate
                    </Button>
                )}
            </InputGroup>
            {/* Progress bar for saving status */}
            {status === STATUS_SAVING && (
                <ProgressBar 
                    now={saveProgress} 
                    label={`${saveProgress}%`} 
                    variant="info"
                    animated
                    striped
                    className="mb-2"
                />
            )}
        </div>
}

export default DateRange